<div id="icc" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Internal Complaint Committee (ICC)</h2>
    <p class="inner-lead mt-3">
      The Internal Complaint Committee (ICC) is constituted under the Sexual Harassment of Women at Workplace
      (Prevention, Prohibition and Redressal) Act, 2013. The committee is committed to maintaining a safe, secure and
      dignified environment for all women on campus.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">ICC Committee Document</h4>

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/grievances/Committee-6.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/grievances/Committee-6.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download ICC Document
      </a>
    </div>

  </div>
</div>